import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]

export type InputProps = {
  value: string | null | undefined;
  hasError?: boolean;
  placeholder?: string;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'ReadOnlyInput',
  props: {
    value: { default: "" },
    hasError: { type: Boolean },
    placeholder: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    class: "form-control",
    value: _ctx.value,
    disabled: ""
  }, null, 8, _hoisted_1))
}
}

})